import { render, staticRenderFns } from "./work-order-pane.vue?vue&type=template&id=2d45a9ae&scoped=true"
import script from "./work-order-pane.vue?vue&type=script&lang=ts"
export * from "./work-order-pane.vue?vue&type=script&lang=ts"
import style0 from "./work-order-pane.vue?vue&type=style&index=0&id=2d45a9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45a9ae",
  null
  
)

export default component.exports